/* SS05909 - "why did this row come back?"
 *
 * A wildcard search runs over every field the reader is authorized to see, not over the columns of
 * the listing they happen to be looking at. That is deliberate (ruled 2026-09-10): narrowing it to
 * the columns would take working search away from every customer with a partial listing, and it
 * would fix nothing about disclosure - field-level authorization already applies to the search.
 *
 * What was missing is the explanation. The server names the field each row matched on (`searchMatch`
 * - "Email", or "Lines > Item" for a table column), and the row shows it ONLY when that field is not
 * already on screen. A match on a visible column explains itself; repeating it would be noise.
 */
export function hiddenSearchMatch(item, columns, searchTerm) {
  const matched = item && item.searchMatch;
  if (!matched || !searchTerm) return '';

  const shown = (columns || [])
    .map(column => String((column && (column.label || column.displayName)) || '').toLowerCase())
    .filter(Boolean);

  // "Lines > Item" is explained by the Lines column being on screen.
  const owner = String(matched).split('>')[0].trim().toLowerCase();

  return shown.includes(String(matched).toLowerCase()) || shown.includes(owner) ? '' : matched;
}

/* The columns a listing actually draws. One switched off in the listing's design is still in its
   column list, but it is not on screen - so a match on it needs explaining like any other. The test
   is the table's and the card's own (FTSTableView / FTSCardView getColumns). */
export function shownColumns(columns) {
  return (columns || []).filter(column =>
    column &&
    (column.show === null || column.show === undefined || column.show === true) &&
    column.hide !== true);
}

export default { hiddenSearchMatch, shownColumns };
